/* Baci Service — moduli i sherbimit ndaj klientit (kontakt, orar, ... ). Ngarkohet PARA baci.js.
   Kontrata: window.BaciService(rawText, state) → null (s'eshte pyetje sherbimi) | string (HTML i plote,
   baci.js e shfaq dhe ndalet) | { html, after: true } (mesazhi ka edhe veture: baci.js pergjigjet
   se pari per pjesen dhe pastaj e shton kete). Gjuha zbulohet nga fjalet e mesazhit (sq/en/de);
   kur s'njihet → anglisht (R26). Fjalet krahasohen si fjale te plota — "orar" nuk e kap "porosi".
   Faktet: vetem FAKTI H (adresa, orari e hene–e shtune 08:00–19:00, 048 770 400, Maps 4.7★).
   E diela NUK eshte e konfirmuar nga pronari — kalohet te WhatsApp-i, nuk shpiket.

   6 shtator 2026 — S1: kontakti, adresa, orari.
   7 shtator 2026 — moduli u be i zgjerueshem: rregullat e tjera jetojne ne baci-service-2.js (S2 transporti, ...)
   dhe regjistrohen te window.BaciServiceRules; ndihmesat jane te window.BaciServiceUtil. Cdo skedar nen ~30 KB.
   8 shtator 2026 — S3 (kthimi, nderrimi, garancioni) ne baci-service-3.js; nje rregull mund te kthej { html, only: true }.
   9 shtator 2026 — S4 (pagesa) ne baci-service-4.js; ketu vetem fjale te reja te gjuhes (pay/bezahlen/pagu). */
window.BaciServiceRules = window.BaciServiceRules || [];
(function () {
  var WA = '38348770400', TEL = '048 770 400', TEL_INT = '+383 48 770 400';
  var MAPS = 'https://maps.app.goo.gl/SA4BzfHk5WicVEAF6', TERMIN = '/pages/termini';
  var ADDR = 'Magjistralja Ferizaj–Prishtinë, Km 1, Ferizaj 70000';

  function norm(s) {
    return (s || '').toLowerCase().replace(/ë/g, 'e').replace(/ç/g, 'c').replace(/ö/g, 'o').replace(/ü/g, 'u')
      .replace(/ä/g, 'a').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* fjale ose fraze e plote brenda tekstit te normalizuar */
  function has(t, phrase) { return (' ' + t + ' ').indexOf(' ' + phrase + ' ') > -1; }
  function any(t, list) { for (var i = 0; i < list.length; i++) if (has(t, list[i])) return true; return false; }
  function count(t, list) { var n = 0; for (var i = 0; i < list.length; i++) if (has(t, list[i])) n++; return n; }

  /* ---------- gjuha ---------- */
  var L_EN = ['the', 'is', 'are', 'do', 'does', 'you', 'your', 'where', 'when', 'how', 'much', 'what', 'can', 'my', 'it', 'have',
    'ship', 'shipping', 'delivery', 'deliver', 'open', 'opening', 'hours', 'hello', 'hi', 'hey', 'price', 'cost', 'return', 'refund',
    'warranty', 'guarantee', 'paint', 'painted', 'install', 'installation', 'order', 'tracking', 'germany', 'switzerland', 'austria',
    'located', 'location', 'address', 'phone', 'sunday', 'saturday', 'today', 'thanks', 'thank', 'send', 'get', 'want', 'need', 'this',
    'for', 'with', 'and', 'please', 'original', 'fit', 'fits', 'bumper', 'diffuser', 'grill', 'lip', 'close', 'time', 'who', 'am', 'talking', 'to',
    'italy', 'uk', 'inside', 'also', 'from', 'if', 'will', 'arrive', 'long', 'does', 'free', 'abroad', 'country', 'pay', 'card', 'accept', 'installments'];
  var L_DE = ['ist', 'sind', 'ihr', 'sie', 'wie', 'viel', 'wo', 'wann', 'was', 'kann', 'ich', 'mein', 'meine', 'eure', 'euer', 'versand',
    'versandkosten', 'lieferung', 'liefert', 'liefern', 'nach', 'deutschland', 'schweiz', 'osterreich', 'offnungszeiten', 'geoffnet',
    'offen', 'samstag', 'samstags', 'sonntag', 'sonntags', 'hallo', 'guten', 'preis', 'kostet', 'kosten', 'ruckgabe', 'garantie',
    'lackieren', 'lackierung', 'lackiert', 'montage', 'einbau', 'einbauen', 'bestellung', 'bestellen', 'habt', 'haben', 'und', 'oder',
    'mit', 'fur', 'nicht', 'danke', 'adresse', 'telefon', 'telefonnummer', 'nummer', 'mochte', 'brauche', 'stossstange', 'diffusor',
    'heckspoiler', 'kuhlergrill', 'passt', 'gibt', 'es', 'das', 'der', 'die', 'den', 'zu', 'bei', 'eine', 'ein', 'seid', 'am', 'um', 'heute',
    'im', 'auch', 'albanien', 'italien', 'moglich', 'wann', 'lange', 'dauert', 'kostenlos', 'ausland', 'wer', 'bist', 'du', 'bezahlen', 'zahlung',
    'zahlungsmethoden', 'nachnahme', 'raten', 'uberweisung', 'welche'];
  var L_SQ = ['a', 'keni', 'ka', 'sa', 'kushton', 'qysh', 'si', 'ku', 'jeni', 'kur', 'orari', 'orarin', 'punoni', 'dergoni', 'transporti',
    'posta', 'per', 'ne', 'dhe', 'ose', 'eshte', 'jam', 'dua', 'kam', 'kthej', 'kthim', 'garancion', 'garancioni', 'lyerja', 'lyeni',
    'montoni', 'montimi', 'porosia', 'porosi', 'gjermani', 'zvicer', 'austri', 'shqiperi', 'kosove', 'faleminderit', 'flm', 'pershendetje',
    'tung', 'tungjatjeta', 'pjese', 'pjesa', 'pjesen', 'parakolp', 'difuzor', 'veture', 'vetura', 'makina', 'vjen', 'mund', 'mundem', 'te',
    'e', 'po', 'jo', 'cka', 'qka', 'cfare', 'shume', 'mire', 'ma', 'thuaj', 'dergesa', 'dite', 'ore', 'diel', 'dielen', 'shtune', 'shtunen',
    'hapur', 'numri', 'numrin', 'telefoni', 'telefonin', 'adresa', 'adresen', 'gjendeni', 'ndodheni', 'dyqani', 'dyqanin', 'lokal', 'sot',
    'neser', 'tash', 'deri', 'prej', 'bon', 'bojne', 'me', 'i', 'u', 'se', 'veq', 'vec', 'kohe', 'edhe', 'pak', 'lire', 'shtrenjte',
    'qoni', 'qu', 'bjen', 'falas', 'nese', 'porosis', 'shkup', 'tirane', 'jashte', 'itali', 'maqedoni', 'turqi', 'nga', 'pagu', 'paguj', 'paguhet',
    'pagesa', 'kesh', 'karte', 'keste', 'dorezim', 'dorzim'];
  function detectLang(t) {
    var en = count(t, L_EN), de = count(t, L_DE), sq = count(t, L_SQ);
    /* pa asnje fjale te njohur: nje-dy fjale (\"whatsapp\", \"g20\") → shqip (parazgjedhja e dyqanit);
       fjali e tere ne gjuhe te panjohur → anglisht (R26) */
    if (!en && !de && !sq) return t.split(' ').length <= 2 ? 'sq' : 'en';
    if (de > sq && de >= en) return 'de';
    if (en > sq && en > de) return 'en';
    return 'sq';
  }

  /* ---------- S1: kontakti, adresa, orari ---------- */
  var DAY_SUN = ['diel', 'dielen', 'dieles', 'diele', 'dielne', 'diella', 'sunday', 'sundays', 'sonntag', 'sonntags'];
  var DAY_SAT = ['shtune', 'shtunen', 'shtunes', 'shtun', 'shtunne', 'saturday', 'saturdays', 'samstag', 'samstags'];
  var HOURS = ['orari', 'orarin', 'orar', 'oraret', 'orarit', 'hapur', 'hapni', 'hapet', 'mbyllni', 'mbyllet', 'mbyllni', 'mbyllin',
    'offnungszeiten', 'geoffnet', 'opening hours', 'business hours', 'working hours', 'are you open', 'you open', 'open today', 'open now',
    'open on', 'do you close', 'you close', 'close today', 'closing time', 'opening time', 'habt ihr offen', 'habt ihr auf', 'ihr offen',
    'ihr geoffnet', 'wann schliesst', 'wann offnet', 'wann macht ihr'];
  var WORK = ['punoni', 'punon', 'punojne', 'puno'];
  var TIME_HINT = ['sot', 'neser', 'tash', 'tani', 'deri', 'prej', 'ora', 'ore', 'oren', 'heute', 'morgen', 'jetzt', 'today', 'now', 'tomorrow', 'time'];
  var ADDRESS = ['ku jeni', 'ku gjendeni', 'ku ndodheni', 'ku e keni', 'ku i keni', 'ku jeni te vendosur', 'ku jeni me dyqan', 'ku je',
    'adresa', 'adresen', 'adrese', 'adresa e dyqanit', 'lokacioni', 'lokacionin', 'lokacion', 'ku eshte dyqani', 'ku e keni dyqanin',
    'ku e keni lokalin', 'a keni lokal', 'a keni dyqan', 'keni lokal', 'lokali', 'where are you', 'where is your', 'where is the shop',
    'address', 'location', 'located', 'directions', 'wo seid ihr', 'wo sind sie', 'wo ist', 'wo befindet', 'adresse', 'standort', 'wo finde ich euch'];
  var CONTACT = ['numri', 'numrin', 'numer', 'numri i telefonit', 'telefoni', 'telefonin', 'telefon', 'tel', 'whatsapp', 'whatsap', 'wapp',
    'viber', 'kontakt', 'kontakti', 'kontaktoj', 'kontaktojme', 'ju kontaktoj', 'si ju gjej', 'ju marr ne telefon', 'me ju marr',
    'instagram', 'insta', 'tiktok', 'facebook', 'fb', 'phone', 'number', 'contact', 'call', 'call you', 'telefonnummer', 'nummer',
    'anrufen', 'erreichen'];
  var EMAIL = ['email', 'e mail', 'mail', 'emaili', 'emailin', 'mejl'];
  var ORDER_WORDS = ['porosi', 'porosia', 'porosine', 'porosise', 'porosit', 'porosia ime', 'order', 'my order', 'bestellung', 'bestellnummer'];

  function s1Intent(t) {
    var sun = any(t, DAY_SUN), sat = any(t, DAY_SAT), hrs = any(t, HOURS), work = any(t, WORK), time = any(t, TIME_HINT);
    var addr = any(t, ADDRESS), contact = any(t, CONTACT), email = any(t, EMAIL), order = any(t, ORDER_WORDS);
    if (work && (sun || sat || time || t === 'a punoni' || t === 'punoni')) hrs = true;
    if ((sun || sat) && !hrs && !work && !addr && !contact && !email) {
      /* "te shtunen" vetem, ose "a vini te shtunen" — pa fjale tjeter sherbimi: mos e kap gabimisht */
      if (!/^(a )?(jeni|punoni|hapur|jeni hapur|open|geoffnet|offen)/.test(t) && t.split(' ').length > 4) return null;
      hrs = true;
    }
    if (sun && (hrs || work)) return 'sunday';
    if (hrs) return 'hours';
    if (addr) return 'address';
    if (email) return order ? null : 'email';
    if (contact) return order ? null : 'contact';
    return null;
  }

  function waLink(text, label) {
    return '<a class="bacilink" target="_blank" rel="noopener" href="https://wa.me/' + WA + '?text=' + encodeURIComponent(text) + '">' + esc(label) + '</a>';
  }
  function mapsLink(label) { return '<a class="bacilink" target="_blank" rel="noopener" href="' + MAPS + '">' + esc(label) + '</a>'; }
  function termLink(label) { return '<a class="bacilink" href="' + TERMIN + '">' + esc(label) + '</a>'; }

  var T = {
    sq: {
      addr: 'Jemi në <b>Ferizaj</b> — ' + esc(ADDR) + ' (' + mapsLink('Google Maps') + ', 4.7★).',
      hours: 'Orari: <b>e hënë–e shtunë, 08:00–19:00</b>.',
      sunday: 'Për <b>të dielën</b> nuk ta konfirmoj dot këtu — orari ynë i rregullt është e hënë–e shtunë 08:00–19:00; shkruaj në WhatsApp dhe ekipi ta thotë a jemi hapur.',
      contact: 'Telefon / WhatsApp: <b>' + TEL + '</b> (përgjigjemi deri në 19:00). Instagram dhe TikTok: @autopjesbajrami.',
      email: 'Më e shpejta është WhatsApp: <b>' + TEL + '</b> — aty i merr të gjitha përgjigjet (deri në 19:00), ose vjen te dyqani në Ferizaj.',
      wa: { sunday: 'Përshëndetje, a jeni hapur të dielën?', hours: 'Përshëndetje, deri në sa ora punoni sot?', address: 'Përshëndetje, ku e keni dyqanin?', contact: 'Përshëndetje, kam një pyetje.', email: 'Përshëndetje, kam një pyetje.' },
      waLabel: 'Vazhdo në WhatsApp', term: 'Cakto termin'
    },
    en: {
      addr: 'We\'re in <b>Ferizaj, Kosovo</b> — ' + esc(ADDR) + ' (' + mapsLink('Google Maps') + ', 4.7★).',
      hours: 'Open <b>Monday–Saturday, 08:00–19:00</b>.',
      sunday: 'I can\'t confirm <b>Sunday</b> here — our regular hours are Monday–Saturday 08:00–19:00; message us on WhatsApp and the team will tell you if we\'re open.',
      contact: 'Phone / WhatsApp: <b>' + TEL_INT + '</b> (' + TEL + ' locally; we reply until 19:00). Instagram and TikTok: @autopjesbajrami.',
      email: 'The fastest way is WhatsApp: <b>' + TEL_INT + '</b> — you get every answer there (until 19:00), or visit the shop in Ferizaj.',
      wa: { sunday: 'Hello, are you open on Sunday?', hours: 'Hello, until what time are you open today?', address: 'Hello, where exactly is the shop?', contact: 'Hello, I have a question.', email: 'Hello, I have a question.' },
      waLabel: 'Continue on WhatsApp', term: 'Book an appointment'
    },
    de: {
      addr: 'Wir sind in <b>Ferizaj, Kosovo</b> — ' + esc(ADDR) + ' (' + mapsLink('Google Maps') + ', 4,7★).',
      hours: 'Geöffnet <b>Montag–Samstag, 08:00–19:00</b>.',
      sunday: 'Für <b>Sonntag</b> kann ich es hier nicht bestätigen — unsere regulären Zeiten sind Montag–Samstag 08:00–19:00; schreib uns auf WhatsApp, das Team sagt dir, ob wir offen sind.',
      contact: 'Telefon / WhatsApp: <b>' + TEL_INT + '</b> (' + TEL + ' vor Ort; wir antworten bis 19:00). Instagram und TikTok: @autopjesbajrami.',
      email: 'Am schnellsten geht es über WhatsApp: <b>' + TEL_INT + '</b> — dort bekommst du jede Antwort (bis 19:00), oder komm im Laden in Ferizaj vorbei.',
      wa: { sunday: 'Hallo, habt ihr am Sonntag geöffnet?', hours: 'Hallo, bis wann habt ihr heute geöffnet?', address: 'Hallo, wo genau ist der Laden?', contact: 'Hallo, ich habe eine Frage.', email: 'Hallo, ich habe eine Frage.' },
      waLabel: 'Weiter auf WhatsApp', term: 'Termin vereinbaren'
    }
  };

  function s1Html(sub, lang) {
    var x = T[lang] || T.en, parts;
    if (sub === 'sunday') parts = [x.sunday, x.addr, x.contact];
    else if (sub === 'hours') parts = [x.hours, x.addr, x.contact];
    else if (sub === 'address') parts = [x.addr, x.hours, x.contact];
    else if (sub === 'email') parts = [x.email, x.addr, x.hours];
    else parts = [x.contact, x.addr, x.hours];
    return parts.join(' ') + '<p class="bacinext">' + waLink(x.wa[sub] || x.wa.contact, x.waLabel) + ' · ' + termLink(x.term) + '</p>';
  }

  /* ---------- hyrja ---------- */
  function hasCar(raw) {
    try {
      if (!window.BaciParse) return false;
      var p = window.BaciParse(raw);
      return !!((p.units && p.units.length) || (p.amb && p.amb.length) || p.brandOnly);
    } catch (e) { return false; }
  }

  window.BaciService = function (raw, state) {
    var t = norm(raw);
    if (!t) return null;
    var lang = detectLang(t), parts = [], rules = window.BaciServiceRules || [];
    var s1 = s1Intent(t);
    if (s1) parts.push(s1Html(s1, lang));
    /* modulet e tjera (baci-service-2.js, ...) regjistrohen te window.BaciServiceRules: fn(t, lang, raw) → html | null */
    /* 8 shtator: nje rregull mund te kthej { html, only: true } — pergjigja e saj zevendeson te tjerat (S3 kthimi mbi S2 "poste") */
    for (var i = 0; i < rules.length; i++) {
      try {
        var h = rules[i](t, lang, raw);
        if (h && typeof h === 'object' && h.only) { parts = [h.html]; break; }
        if (h) parts.push(typeof h === 'object' ? h.html : h);
      } catch (e1) {}
    }
    if (!parts.length) return null;
    var html = parts.join('');
    return hasCar(raw) ? { html: html, after: true } : html;
  };
  window.BaciLang = detectLang;
  window.BaciServiceUtil = { norm: norm, esc: esc, has: has, any: any, count: count, waLink: waLink, termLink: termLink, detectLang: detectLang };
  window.BACI_SERVICE_READY = true;
})();
